export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/CH-68bdac0b6a8c08dc7140ee30c9be96f3.png";